import { ShopView } from './views/shop/ShopView'
export default ShopView
